import React from 'react';
import Gallery from './Gallery';
import { Box, Typography } from '@mui/material';

const Recordings = () => {
  return (
    <Box sx={{ padding: '20px' }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Recordings
      </Typography>
      <Gallery />
    </Box>
  );
};

export default Recordings;
